import { Injectable } from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import { AuthUserInfoModel } from '../models/auth-user-info-model';
import { AccountDetailsModel } from '../models/account-details-model';
import { ChangePasswordModel } from '../models/change-password-model';
import {ConfirmTotpModel} from '../models/confirm-totp-model';
import {LoginResultModel} from '../models/login-result-model';

@Injectable({
  providedIn: 'root'
})
export class MyAccountService {
  readonly apiPath = 'my-account/';
  constructor(
    private http: HttpClient,
  ) { }

  private missionAnnouncedSource = new Subject<string>();

  missionAnnounced$ = this.missionAnnouncedSource.asObservable();

  announceMission(mission: string) {
    this.missionAnnouncedSource.next(mission);
  }

  getAccountDetails() {
    return this.http.get(this.apiPath + 'details') as Observable<AccountDetailsModel>;
  }

  getCurrentUser() {
    return this.http.get(this.apiPath + 'info') as Observable<AuthUserInfoModel>;
  }

  changePassword(model: ChangePasswordModel): Observable<Object> {
    return this.http.post(this.apiPath + 'change-password', model);
  }

  activateTotp(): Observable<HttpResponse<Blob>> {
    return this.http.post( this.apiPath + 'totp/activate', {oh:1}, { params: null, responseType: 'blob', observe: 'response' } );
  }

  confirmTotp(model: ConfirmTotpModel): Observable<LoginResultModel> {
    return this.http.post(this.apiPath + 'totp/confirm', model) as Observable<LoginResultModel>;
  }
}
